export const textractKeys = {
  all: ['textract'] as const,
  fieldsMapping: (documentID: string) => [...textractKeys.all, 'fieldsMapping', documentID] as const,
};
